var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPytestIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24822 2.52551H28.7212C29.0525 2.52551 29.3702 2.65711 29.6044 2.89135C29.8387 3.12559 29.9703 3.44329 29.9703 3.77456C29.9703 4.10583 29.8387 4.42353 29.6044 4.65778C29.3702 4.89202 29.0525 5.02361 28.7212 5.02361H3.24822C2.91727 5.02328 2.59998 4.89167 2.36596 4.65765C2.13194 4.42364 2.00033 4.10634 2 3.77539C2 3.44419 2.13146 3.12653 2.36549 2.89218C2.59953 2.65783 2.91702 2.52595 3.24822 2.52551Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47052 0H8.59096V1.18174H3.47052V0Z",
    fill: "#009FE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1691 0H15.29V1.18174H10.1691V0Z",
    fill: "#C7D302"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7767 0H21.8992V1.18174H16.7767V0Z",
    fill: "#F07E16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3585 0H28.4794V1.18174H23.3585V0ZM23.3585 6.3242H28.4794V14.9815H23.3585V6.3242Z",
    fill: "#DF2815"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7767 6.32422H21.9092V20.3883H16.7767V6.32422Z",
    fill: "#F07E16"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1691 6.32422H15.29V27.3902H10.1691V6.32422Z",
    fill: "#C7D302"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47052 6.32422H8.59096V32H3.47052V6.32422Z",
    fill: "#009FE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytestIntegration);
export default __webpack_public_path__ + "static/media/pytest-integration.938a6b5472d7cc6806b8e548c331a166.svg";
export { ForwardRef as ReactComponent };